import { FaFacebook, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import Question from '../compnents/Question';
import { useTranslation } from 'react-i18next';
import PricingPage from '../compnents/pricing';
const Contact = () => {
	const { t } = useTranslation();
	return (
		<main className='mt-28 '>
			<section className='h-[30vh] bg-main flex justify-center items-center text-white text-4xl font-bold'>
				<h2>{t('contactUs')}</h2>
			</section>

			<section className='flex justify-center items-center my-10'>
				<a
					href='https://wa.me/qr/MJTCYGYOGITOJ1'
					target='_blank'
					rel='noreferrer'
					className='text-main text-lg mt-4 block text-center'>
					<div className='border-2 border-main p-4 rounded-md'>
						<h3 className='text-center text-2xl font-semibold mb-4'>Scan Me</h3>
						<img
							src={'/images/whatsappQRCode.jpeg'}
							alt='WhatsApp QR Code'
							className='w-48 h-48 object-contain'
						/>
					</div>
				</a>
			</section>

			<section className='my-20 container'>
				<div className='flex flex-col gap-6 md:flex-row md:justify-between '>
					{[
						{
							icon: '/images/phone.png',
							title: t('ourPhone'),
							detail: '+20 11 50020781',
							href: 'https://wa.me/qr/MJTCYGYOGITOJ1',
						},
						{
							icon: '/images/email.png',
							title: t('ourEmail'),
							detail: 'schema.aiot@gmail.com',
							href: 'mailto:schema.aiot@gmail.com',
						},
						{
							icon: '/images/location.png',
							title: t('ourAddress'),
							detail: t('addressDetails'),
							href: 'https://maps.app.goo.gl/ttkMyYn9N3dcQcbJ6',
						},
					].map((item, index) => (
						<div
							key={index}
							className='card p-4 bg-[#f0f4f9] flex gap-4 items-center md:w-1/3 rounded-md'>
							<a
								href={item.href}
								target='_blank'
								rel='noreferrer'
								key={index}>
								<div className='image-container text-white border-2 border-secondary rounded-full w-16 h-16 p-2 flex justify-center items-center'>
									<img
										loading='lazy'
										src={item.icon}
										alt={item.title}
										className='w-8 h-8 object-contain'
									/>
								</div>
								<div className='description'>
									<h3 className='text-main text-xl font-semibold'>
										{item.title}
									</h3>
									<p className='text-xlg text-textColor'>{item.detail}</p>
								</div>
							</a>
						</div>
					))}
				</div>
			</section>

			<section className='container mb-20 flex flex-col md:flex-row gap-8 pt-16'>
				<div className='description flex flex-col gap-4 md:w-1/3'>
					<h5 className='text-main font-semibold'>{t('getInTouch')}</h5>
					<p className='text-main text-2xl font-bold md:text-4xl'>
						{t('writeUsMessage')}
					</p>
					<h5 className='text-textColor text-sm'>
						{t('placeholderParagraph')}
					</h5>
					<div className='links flex gap-3'>
						{[
							{
								icon: FaFacebook,
								href: 'https://www.facebook.com/profile.php?id=61550304061074&mibextid=ZbWKwL',
							},
							{ icon: FaWhatsapp, href: 'https://wa.me/qr/MJTCYGYOGITOJ1' },
							{ icon: FaEnvelope, href: 'mailto:schema.aiot@gmail.com' },
						].map((item, index) => (
							<a
								key={index}
								href={item.href}
								target='_blank'
								rel='noreferrer'
								className='flex justify-center items-center rounded-full w-10 h-10 p-2 text-[#ccd5df] text-lg border-[1px] border-[#ccd5df] border-solid md:hover:text-main md:hover:bg-secondary md:hover:border-secondary transform-all duration-500'>
								<item.icon />
							</a>
						))}
					</div>
				</div>

				<Question />
			</section>

			{/* <PricingPage /> */}
		</main>
	);
};

export default Contact;
